import {
    ChangeDetectorRef,
    Component,
    EventEmitter,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    SimpleChanges
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import moment from 'moment';
import { combineLatest } from 'rxjs';
import { startWith, takeWhile } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import * as fromDataServices from '../../data-services';
import * as fromShared from '../../shared';
import { SelectItem, uniqBy } from '../../shared';
import { LoggingService } from '../../shared/services/logging';

@Component({
    selector: 'ef-email-audit-presenter',
    templateUrl: './email-audit-presenter.component.html',
    styleUrls: ['./email-audit-presenter.component.scss'],
    standalone: false
})
export class EmailAuditPresenter
    extends fromShared.EditGrid<fromDataServices.EmailAudit.EmailAuditModel>
    implements OnInit, OnDestroy, OnChanges {
    public filterFormGroup: UntypedFormGroup;
    private active = true;
    dropdownItemHeight = environment.dropdownItemHeight;
    messageTypes: SelectItem[] = [];
    numCols = 7;
    moment;
    cols: { field: string; header: string }[] = [
        { field: 'Type', header: 'Type' },
        { field: 'MessageDate', header: 'MessageDate' },
        { field: 'Subject', header: 'Subject' },
        { field: 'Message', header: 'Message' },
        { field: 'Recipient', header: 'Recipient' },
        { field: 'ReplyAddress', header: 'ReplyAddress' },
        { field: 'Status', header: 'Status' }
    ];
    @Output() DateFiltersChanged = new EventEmitter<{
        startDate: Date;
        endDate: Date;
    }>();
    constructor(private log: LoggingService, private cdRef: ChangeDetectorRef) {
        super();
        this.moment = moment;
        this.filterFormGroup = new UntypedFormGroup({
            endDate: new UntypedFormControl(new Date()),
            startDate: new UntypedFormControl(moment().add(-1, 'months').toDate())
        });
    }

    ngOnInit(): void {
        combineLatest([
            this.filterFormGroup.controls['startDate'].valueChanges.pipe(
                startWith(this.filterFormGroup.controls['startDate'].value)
            ),
            this.filterFormGroup.controls['endDate'].valueChanges.pipe(
                startWith(this.filterFormGroup.controls['endDate'].value)
            )
        ])
            .pipe(
                takeWhile(_ => this.active)
                // debounceTime(500)
            )
            .subscribe(([startDate, endDate]) => {
                this.DateFiltersChanged.emit({
                    startDate,
                    endDate
                    // : moment(x[1]).add(1, 'days').toDate() // add 1 day to end date to include the end date
                });
            });
    }
    ngOnDestroy(): void {
        this.active = false;
    }
    ngOnChanges(changes: SimpleChanges): void {
        super.ngOnChanges(changes);
        if (
            changes.items &&
            changes.items.currentValue &&
            changes.items.currentValue.length > 0
        ) {
            this.log.verbose({
                type: 'EmailAuditPresenter: ngOnChanges',
                changes
            });
            this.messageTypes = uniqBy(this.items, i => i.Type).map(i => ({
                label: i.Type,
                value: i.Type
            }));
            this.dataTable.multiSortMeta = [
                //{ field: 'Type', order: 1 },
                //{ field: 'MessageDate', order: 1 }
            ];
            this.dataTable.sortMultiple();
            this.cdRef.detectChanges();
        }
    }
}
